import { Footer } from './Footer';
import { MergedStepComponentProps } from '../MergeEmployeesDialog.types';
import {
	DialogSteps,
	Grid,
	Text,
	GridItem,
	Alert,
	Stack,
	Field,
	Input,
} from '@welbe/design-system';
import { LuCake, LuMail, LuPhone } from 'react-icons/lu';
import { SectionIconText } from './SectionIconText';
import { FaRegAddressCard } from 'react-icons/fa';
import { LiaTransgenderSolid } from 'react-icons/lia';
import { useState } from 'react';

export const ConfirmFusion = ({
	onBack,
	onNext,
	onClose,
	loading,
	employees,
	primaryEmployeeId,
}: MergedStepComponentProps) => {
	const [reason, setReason] = useState('');
	const [confirmation, setConfirmation] = useState('');
	const primary = employees.find((e) => e.id === primaryEmployeeId);

	return (
		<>
			<DialogSteps.Body>
				<Stack gap="2rem" pt="1rem">
					<Alert.Root status="error">
						<Alert.Indicator />
						<Alert.Content>
							<Alert.Title fontWeight="bold">
								Estas por unificar información sensible del colaborador
							</Alert.Title>
							<Alert.Description>
								Recuerda que es tu responsabilidad registrar y asegurar que los
								cambios realizados en el perfil de los colaboradores son
								correctos.
							</Alert.Description>
						</Alert.Content>
					</Alert.Root>
					<Stack gap="1.5rem">
						<Text fontSize="md" fontWeight="600">
							Motivo de fusión
						</Text>

						<Field.Root required>
							<Field.Label>
								Describe el motivo por el cual estás fusionando los expedientes{' '}
								<Field.RequiredIndicator />
							</Field.Label>
							<Input
								placeholder="Agrega tu descripción"
								onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
									setReason(e.target.value)
								}
							/>
						</Field.Root>

						<Stack
							p="0.75rem 1rem"
							w="478px"
							border="1px solid"
							borderColor="gray.200"
							borderRadius="lg"
							display="flex"
							flexDirection="column"
							gap="1rem"
						>
							<Text fontWeight="600" fontSize="sm" lineHeight="20px">
								{primary?.name}
							</Text>
							<Grid templateColumns="1fr 1fr" gap="0.5rem">
								<GridItem colSpan={2}>
									<SectionIconText
										icon={<FaRegAddressCard />}
										label={primary?.nationalIdentity || '-'}
									/>
								</GridItem>
								<SectionIconText
									icon={<LuCake />}
									label={primary?.birthDate || '-'}
								/>

								<SectionIconText
									icon={<LiaTransgenderSolid />}
									label={primary?.gender || '-'}
								/>

								<SectionIconText
									icon={<LuMail />}
									label={primary?.email || primary?.alternativeEmail || '-'}
								/>

								<SectionIconText
									icon={<LuPhone />}
									label={primary?.phone || primary?.alternativePhone || '-'}
								/>
							</Grid>
						</Stack>

						<Stack
							bg="gray.100"
							p="0.75rem 1rem"
							borderRadius="lg"
							gap="1.5rem"
						>
							<Text fontSize="sm" fontWeight="600" color="blue.500">
								Completa la información para confirmar el cambio en el
								expediente del colaborador
							</Text>

							<Field.Root required value={confirmation}>
								<Field.Label>
									Escribe <strong>{primary?.name.toUpperCase()}</strong> para
									confirmar la fusión del expediente
									<Field.RequiredIndicator />
								</Field.Label>
								<Input
									placeholder="Escribe el Nombre"
									bg="white"
									onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
										setConfirmation(e.target.value)
									}
									onPaste={(e) => {
										e.preventDefault();
										setConfirmation((prev) => prev);
									}}
								/>
							</Field.Root>
						</Stack>
					</Stack>
				</Stack>
			</DialogSteps.Body>
			<Footer
				onBack={onBack}
				onClose={onClose}
				onNext={() => onNext(primaryEmployeeId, reason)}
				loading={loading}
				nextDisabled={
					!reason || confirmation.toUpperCase() !== primary?.name.toUpperCase()
				}
			/>
		</>
	);
};
